import { Node, nodeInputRule } from "@tiptap/core"
import { renderMathToHTML } from "../lib/math"

export const MATH_BLOCK_NODE = "math"

const inputRegex = /^\$\$\s$/

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    math: {
      insertMathBlock: (attrs?: { latex?: string }) => ReturnType
    }
  }
}

export const MathBlock = Node.create({
  name: MATH_BLOCK_NODE,
  group: "block",
  atom: true,
  draggable: true,
  selectable: true,

  addAttributes() {
    return {
      latex: {
        default: "",
        parseHTML: element => element.getAttribute("data-latex") ?? "",
      },
      emailImageUrl: {
        default: null,
        rendered: false,
      },
      emailImageWidth: {
        default: null,
        rendered: false,
      },
      emailImageHeight: {
        default: null,
        rendered: false,
      },
    }
  },

  parseHTML() {
    return [{ tag: `div[data-type="${MATH_BLOCK_NODE}"]` }]
  },

  renderHTML({ node }) {
    const latex = node.attrs.latex
    return [
      "div",
      {
        "data-type": MATH_BLOCK_NODE,
        "data-latex": latex,
        class: "math-display",
      },
      latex ? renderMathToHTML({ latex, displayMode: true }) : latex,
    ]
  },

  addCommands() {
    return {
      insertMathBlock:
        (attrs = {}) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: { latex: attrs.latex ?? "" },
          })
        },
    }
  },

  addInputRules() {
    return [
      nodeInputRule({
        find: inputRegex,
        type: this.type,
        getAttributes: () => ({ latex: "" }),
      }),
    ]
  },

  addKeyboardShortcuts() {
    return {
      "Mod-Shift-m": () => this.editor.commands.insertMathBlock(),
    }
  },
})
